export default __webpack_public_path__ + "static/media/lns-logomark.cc0e6bb1.svg";